<template>
  <div id="main">
    <Aside></Aside>
    <!-- <ScreenAdapter @scrollVal="listenScroll"> -->
    <div class="party-header">
      <Header :hideBg="true" :active="!$route.query.key ? key : null">
      </Header>
    </div>
    <div class="eol-main-container">
      <div class="tabs-content">
        <div class="course-info">
          <div class="course-info-inner">
            <!-- hide-play 课程时长为0,不显示播放按钮 -->
            <div :class="['l-thumb', courseInfo && courseInfo.total_time == '00:00:00' ? 'hide-play' : '']" @click="jumpDetail()">
              <div class="img">
                <div class="c-img" :style="`background:url(${(courseInfo && courseInfo.photo) ? courseInfo.photo : ''}) no-repeat center/cover;`">
                </div>
              </div>
            </div>
            <div class="r-info">
              <div class="title">
                <div class="text">{{ courseInfo && courseInfo.name }}</div>
              </div>
              <div class="category">
                <div class="category-label">分类</div>
                <div class="category-text">{{ courseInfo && courseInfo.category_name &&
                  courseInfo.category_name.replace(/-/, "-") }}</div>
              </div>
              <div class="content-label">课程介绍</div>
              <div class="content">
                <div v-html="chapterInfo.length == 0 ? '无' : intro"></div>
              </div>
            </div>
          </div>
        </div>
        <template>
          <template v-if="!chapterInfo.length == 0">
            <!-- 课程内容 -->
            <div class="video-content" id="detail" :ref="chapterInfo && chapterInfo.length > 0 ? 'color' : ''" v-if="chapterInfo && chapterInfo.length > 0">
              <div class="details-color">
                <div class="content-header" ref="ref-1">
                  <div class="text">课程内容</div>
                </div>
                <template>
                  <div class="content-box">
                    <div :class="['item', item.type == '2' ? 'word' : '']" v-for="item, index in chapterInfo" :key="index" @click="jumpDetail(item.id)">
                      <div class="img">
                        <div class="c-img" :style="`background:url(${item.photo}) no-repeat center/cover`"></div>
                      </div>
                      <template>
                        <el-tooltip :content="item.name" placement="bottom" v-if="item.type == '1'">
                          <div class="title">{{ item.name }}</div>
                        </el-tooltip>
                        <div class="title" v-else>{{ item.name }}</div>
                      </template>
                    </div>
                    <div class="flex-hide"></div>
                    <div class="flex-hide"></div>
                  </div>
                  <a-pagination v-if="pageNum && pageNum > 1" :defaultPageSize="size" :default-current="1" :total="total" @change="onChange" />
                </template>
              </div>

            </div>

            <div class="appraise-cont">
              <!-- 课程评价 -->
              <div class="details-appraise" :ref="(!chapterInfo || chapterInfo.length == 0) ? 'color' : ''">
                <div id="appraise"></div>
                <div class="appraise-content" ref="ref-3">
                  <div class="content-header">
                    <div class="text">课程评价</div>
                  </div>

                  <div class="content-box">
                    <template v-if="appraiseList && appraiseList.length > 0">
                      <div class="appraise-item" v-for="item, index in appraiseList" :key="index">
                        <template>
                          <div class="avatar"></div>
                          <div class="appraise-info">
                            <div class="basic-info">
                              <div class="user-info">
                                <div class="user-name">{{ item.user_name }}</div>
                                <div class="star-content">
                                  <div :class="['star-item', s_index + 1 > item.level ? 'empty' : '']" v-for="s_item, s_index in 5" :key="s_index"></div>
                                </div>
                              </div>
                              <div class="publish-time">{{ item.created_at }}</div>
                            </div>
                            <div class="appraise-text" v-text="item.content"></div>
                          </div>
                        </template>
                      </div>
                    </template>
                    <div class="empty-content" v-else>
                      <p class="empty-text">暂无评价~</p>
                    </div>

                  </div>
                </div>
              </div>
              <!-- 课程评价分页 -->
              <a-pagination show-less-items style="margin:0 0 30px;" v-if="appraisePageNum && appraisePageNum > 1" :defaultPageSize="appraiseSize" :default-current="1" :total="appraiseTotal" @change="appraiseOnChange" />

              <!-- 评价 -->
              <div class="appraise-container">
                <div class="appraise-header">
                  <div class="appraise-star">
                    <div class="header-text">请对课程进行评价</div>
                    <div class="header-score">
                      <div :class="['score-item', index + 1 > appraiseScore ? 'unActive' : '']" v-for="item, index in 5" :key="index" @click="handleScore(index)"></div>
                    </div>
                  </div>
                  <div class="appraise-submit" @click="appraiseSubmit()">发表</div>
                </div>
                <div class="appraise-area">
                  <textarea placeholder="在这里输入你的评价~" v-model="appraiseContent"></textarea>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="construct-content">
              <img src="../../../assets/custom/party/detail/construct.png">
              <p>课程建设中，敬请期待</p>
            </div>
          </template>
        </template>

      </div>
    </div>
    <Footer v-if="!chapterInfo.length == 0" />
    <!-- </ScreenAdapter> -->
    <div v-if="!chapterInfo.length == 0" :class="['fixed-nav', isFixed ? 'fixed' : '']" :style="{ top: !isFixed ? style.top : '', left: style.left, transform: scrollStyle }">
      <div @click="toPosition('#detail', 1)" :class="['fixed-nav-item', isFixedId == 1 ? 'active' : '']" v-if="chapterInfo && chapterInfo.length > 0">课程内容</div>
      <div @click="toPosition('#appraise', 3)" :class="['fixed-nav-item', isFixedId == 3 ? 'active' : '']">课程评价</div>
    </div>

  </div>
</template>

<script>
import Header from "@/components/Custom/Party/Header.vue"
import Footer from "@/components/Custom/Party/Footer"
import services from '@/config/services'
import { Message } from "ant-design-vue"
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
import { mapState } from "vuex"
import utils from "../../../config/utils"
import Aside from "../../../components/Custom/Party/Aside.vue";
export default {
  data () {
    return {
      zh_CN,
      school_code: utils.getUrlSchoolCode(window.location.pathname) || localStorage.getItem("schoolCode"),
      cover: "", // 动态封面图
      appraiseList: [],//评价列表
      appraiseContent: "",// 评价内容
      appraiseScore: 5, // 评价分数
      windowHeight: document.documentElement.clientHeight, // 可视窗口高度
      isFixed: false, // 是否固定左侧菜单
      isFixedId: 1, // 当前固定的菜单id
      courseInfo: {}, // 课程详细
      chapterInfo: [], // 课程章节
      firstId: "",// 一级课程分类

      keyList: [
        { path: "culture", id: "106", course_ids: [107, 108, 109, 118] },
        { path: "value", id: "110", course_ids: [111, 112, 113] },
        { path: "feelings", id: "121", course_ids: [193, 194] },
        { path: "profession", id: "136", course_ids: [137, 139] },
        { path: "feature", id: "", course_ids: [201, 202] },
        { path: "vita", id: "152", course_ids: [153, 154, 155, 156] },
      ],
      coverList: [
        { path: "culture", cover: require('../../../assets/hzvtc/cover/culture.png') },
        { path: "value", cover: require('../../../assets/hzvtc/cover/value.png') },
        { path: "feelings", cover: require('../../../assets/hzvtc/cover/feelings.png') },
        { path: "profession", cover: require('../../../assets/hzvtc/cover/profession.jpg') },
        { path: "feature", cover: require('../../../assets/hzvtc/cover/feature.png') },
        { path: "vita", cover: require('../../../assets/hzvtc/cover/vita.jpg') },
      ],
      key: "",
      style: {
        top: "",
        left: ""
      },
      studyBan: false, // 是否可以学习
      intro: "", // 课程简介
      scrollStyle: "",
      scale: "",
      page: 1,
      size: 16,
      total: 0,
      pageNum: 0,

      appraisePageNum: 0, // 课程评价总页数
      appraiseSize: 10, // 课程评价一页显示几条
      appraiseTotal: 0, // 课程评价总条数
      appraisePage: 1, // 课程评价-当前页码
    }
  },
  components: {
    Header,
    Footer,
    Aside,
    // ScreenAdapter
  },
  async mounted () {
    let that = this
    let key = that.$route.query.key || localStorage.getItem("eol-hzvtc-detail-key") || that.key
    that.key = key
    if (that.$route.query.reload) {
      window.open(`/center/${that.school_code}/custom/party/detail?id=${that.$route.query.id || localStorage.getItem("hz-id")}&key=${key}`, "_self")
    }
    window.addEventListener("scroll", that.handleScroll, true)
    await that.getCourseDetails()
    await that.getCourseChapterDetail()
    await that.getCourseComment()
    await that.handleScroll()
  },
  methods: {
    // 改变评价星级
    handleScore (val) {
      this.appraiseScore = val + 1
    },
    // 跳转到课程详情
    jumpDetail (cmid, self) {
      if (this.courseInfo && this.courseInfo.total_time == '00:00:00') return
      if (this.studyBan) {
        return Message.error("您暂无权限学习")
      }
      let key = this.$route.query.key || localStorage.getItem("eol-hzvtc-detail-key")
      let palyId = cmid ? cmid : 0

      // 记录key 课程id,防止播放课程页点击返回参数丢失
      localStorage.setItem("eol-hzvtc-detail-key", key)
      localStorage.setItem("hz-id", this.$route.query.id)
      if (self) {
        return window.open(`/center/${this.school_code}/hzvtc/detail?id=${cmid}&key=${key}`, true)
      }
      if (!this.loginUserInfo) {
        return window.open(`${services.APPS_SERVIER}/api/redirect?school_code=${this.school_code}&from=${window.location.href}`, "_self")

      }
      window.open(`/center/${this.school_code}/video/${this.courseInfo.id}/${palyId}?from=${this.$route.path}&id=${cmid}&key=${key}`, "_blank")
    },
    // 提交评价
    async appraiseSubmit () {
      if (this.appraiseContent.length < 5) {
        return Message.error("至少输入5个字")
      }
      await services.addCourseComment({ course_id: this.$route.query.id, level: this.appraiseScore, content: this.appraiseContent }).then(res => {
        if (res.code == '0000') {
          Message.success("评价成功");
          this.getCourseComment()
          this.appraiseContent = ""
        } else {
          Message.error(res.message);
        }
      })
    },
    handleScroll () {
      let that = this
      that.$nextTick(() => {
        let scrollTop = document.body.scrollTop;
        that.isFixed = scrollTop >= 435 ? true : false
        let div1 = that.$refs['ref-1']
        let div2 = that.$refs['ref-2']
        let div3 = that.$refs['ref-3']
        if (div1 && div1.getBoundingClientRect().top + 50 > 0) {
          that.isFixedId = 1
        } else if (div2 && div2.getBoundingClientRect().top + 50 > 0) {
          that.isFixedId = 2
        } else if (div3 && div3.getBoundingClientRect().top + 50 > 0) {
          that.isFixedId = 3
        }
      })
    },
    // 锚点定位
    toPosition (node, id) {
      document.querySelector(node).scrollIntoView(true);
      this.isFixedId = id
    },
    // 获取课程详情
    async getCourseDetails () {
      let that = this
      await services.getCourseDetails({ id: that.$route.query.id }).then(res => {
        that.courseInfo = res.data
        var html = res.data.intro
        html = html.replace(/\s\s+/g, '');
        that.intro = html
      })
    },
    // 获取课程章节
    getCourseChapterDetail (current) {
      if (!current) {
        services.getCourseChapterDetail({ id: this.$route.query.id, data: { action: "learn" } }).then(res => {
          if (res.code == '2004') {
            // 未加入班级，禁止学习
            this.studyBan = true
          }
        })
      }

      services.getCourseMaterial({ school_code: this.school_code, course_id: this.$route.query.id, page: this.page, size: 16 }).then(res => {
        this.pageNum = res.data.page_num
        this.total = res.data.total
        // this.handleWordCover(res.data.items)
        if (res.data.items && res.data.items.length > 0) {
          this.chapterInfo = this.handleWordCover(res.data.items)
        }
      })
    },
    handleWordCover (arr) {
      let wordList = []
      var coverNumber = 0
      arr.forEach(item => {
        if (item.type == '2') {
          if (coverNumber < 8) {
            coverNumber++
          } else {
            coverNumber = 0
            coverNumber++
          }
          wordList.push({ ...item, photo: require(`../../../assets/custom/party/detail/word-background/${coverNumber}.png`) })
        } else {
          wordList.push(item)
        }
      })
      return wordList
    },
    // 获取课程评价
    async getCourseComment () {
      await services.getCourseComment({ course_id: this.$route.query.id, page: this.appraisePage, size: this.appraiseSize }).then(res => {
        this.appraiseList = res.data.items
        this.appraisePageNum = res.data.page_num
        this.appraiseTotal = res.data.total
      })
    },

    onChange (val) {
      this.page = val
      this.getCourseChapterDetail("current")
      // this.getWordList()
    },


    appraiseOnChange (val) {
      this.appraisePage = val
      this.getCourseComment()
    },

    // 跳转到文档详情模板
    jumpQmt (item) {
      localStorage.setItem("eol-hzvtc-detail-key", this.key)
      if (!this.loginUserInfo) {
        window.open(`${services.APPS_SERVIER}/api/redirect?school_code=${this.school_code}&from=${window.location.href}&reload=1`, "_self")
      } else {
        window.open(`${item.url}?key=${this.key}`, "_blank")
      }
    }

  },
  computed: {
    ...mapState({
      loginUserInfo: (state) => state.appsLogin.appsUserInfo,
    }),


  },
  destroyed () {
    window.removeEventListener("scroll", this.handleScroll)
  }
}
</script>

<style lang="less" scoped>
* {
    font-family: Microsoft YaHei;
}

#main {
    background: #fff;
}

.eol-main-container {
    position: relative;

    .c-img {
        width: 100%;
        height: 100%;
        transition: all 0.7s;

        &::before {
            content: '';
            position: absolute;
            width: 100%;
            height: 100%;
            display: inline-block;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            background: rgba(0, 0, 0, 0.3);
        }
    }

    .tabs-content {
        .course-info {
            border-top: 1px solid rgba(205, 205, 205, 0.9);
            padding: 32px 0;
            background: url('../../../assets/custom/party/detail/info-bg.png')
                no-repeat center/cover;

            .course-info-inner {
                display: flex;
                position: relative;
                z-index: 100;
                width: 1200px;
                margin: 0 auto;

                .l-thumb {
                    cursor: pointer;
                    width: 474px;
                    height: 296px;
                    background: #ffffff;
                    border-radius: 10px;
                    position: relative;
                    margin-right: 35px;
                    flex-shrink: 0;

                    &.hide-play {
                        &::before {
                            display: none;
                        }

                        .c-img {
                            &::before {
                                display: none;
                            }
                        }
                    }

                    &::before {
                        content: '';
                        display: inline-block;
                        width: 80px;
                        height: 80px;
                        background: url('../../../assets/custom/party/detail/play.png')
                            no-repeat center/cover;
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%, -50%);
                        z-index: 10;
                    }

                    .img {
                        width: 420px;
                        height: 236px;
                        overflow: hidden;
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%, -50%);

                        &:hover {
                            .c-img {
                                transform: scale(1.2);
                            }
                        }
                    }
                }

                .r-info {
                    flex: 1;
                    overflow: hidden;

                    .title {
                        font-size: 24px;
                        font-weight: bold;
                        color: #333333;
                        line-height: 1;
                        padding: 22px 0;
                    }

                    .category {
                        display: flex;
                        align-items: center;
                        position: relative;
                        margin-bottom: 20px;

                        .category-label {
                            width: 46px;
                            height: 24px;
                            background: url('../../../assets/custom/party/detail/category-label.png')
                                no-repeat center/cover;
                            text-align: center;
                            line-height: 24px;
                            position: relative;
                            z-index: 10;
                            font-size: 14px;
                            font-weight: bold;
                            color: #6e562c;
                        }

                        .category-text {
                            padding: 5px 13px;
                            line-height: 1;
                            background: #f6e0c8;
                            border-radius: 0px 6px 0px 0px;
                            position: absolute;
                            left: 41px;
                            font-size: 14px;
                            color: #6e562c;
                        }
                    }

                    .content-label {
                        font-size: 16px;
                        font-weight: bold;
                        color: #c1212e;
                        line-height: 1;
                        margin-bottom: 14px;

                        &::before {
                            content: '';
                            display: inline-block;
                            background: url('../../../assets/custom/party/detail/intro-label.png')
                                no-repeat center/cover;
                            width: 15px;
                            height: 16px;
                            margin: 0 10px 0 0;
                            vertical-align: -2px;
                        }
                    }

                    .content {
                        height: 140px;
                        overflow-y: auto;
                        overflow-x: hidden;
                        padding-right: 12px;

                        &::-webkit-scrollbar-thumb {
                            width: 4px;
                            height: 30px;
                            background: #e3c9c9;
                        }

                        &::-webkit-scrollbar-track-piece {
                            background: transparent;
                        }

                        ::v-deep * {
                            font-size: 14px !important;
                            line-height: 24px !important;
                            background: transparent !important;
                            font-family: Microsoft YaHei !important;
                            color: #7d6562 !important;
                        }

                        ::v-deep p {
                            margin-bottom: 8px;
                        }

                        ::v-deep img,
                        ::v-deep video,
                        ::v-deep audio {
                            max-width: 80%;
                            display: block;
                            margin: 0 auto;
                        }
                    }
                }
            }
        }

        .content-header {
            width: 977px;
            height: 61px;
            background: url('../../../assets/custom/party/detail/title.png')
                no-repeat center/contain;
            text-align: center;
            margin: 0 auto;
            font-size: 20px;
            font-weight: bold;
            line-height: 61px;
            position: relative;
            z-index: 100;
            position: relative;

            .text {
                letter-spacing: 5px;
                font-size: 20px;
                font-weight: bold;
                color: #ffffff;
                background: linear-gradient(
                    180deg,
                    #fff9e8 0.146484375%,
                    #f9ca91 100%
                );
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                padding-left: 60px;
            }
        }

        .video-content {
            position: relative;
            z-index: 100;
            padding: 0 0 26px 192px;
            width: 1200px;
            margin: 28px auto 15px;

            &.pb0 {
                padding-bottom: 0;
            }

            .details-color {
                width: 100%;
                min-height: 280px;

                .content-header {
                    margin: 0 0 22px;
                }

                .content-box {
                    display: flex;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    position: relative;

                    .item {
                        position: relative;
                        width: 240px;
                        cursor: pointer;
                        margin-bottom: 14px;

                        &:hover {
                            .c-img {
                                transform: scale(1.2);
                            }
                        }

                        &.word {
                            &::before {
                                content: '';
                                display: block;
                                width: 48px;
                                height: 24px;
                                background: linear-gradient(
                                    0deg,
                                    #f6d4ac 0%,
                                    #fff6e6 100%
                                );
                                border-radius: 0px 0px 0px 10px;
                                position: absolute;
                                top: 0;
                                right: 0;
                                z-index: 1;
                            }

                            &::after {
                                content: '';
                                display: block;
                                width: 26px;
                                height: 11px;
                                position: absolute;
                                top: 6px;
                                right: 10px;
                                background: url('../../../assets/custom/party/detail/type-word.png')
                                    no-repeat center/cover;
                                z-index: 2;
                            }

                            .img {
                                .c-img {
                                    &::before {
                                        opacity: 0;
                                    }
                                }
                            }

                            .title {
                                text-align: center;
                                bottom: auto;
                                padding: 0 24px;
                                position: absolute;
                                background: none;
                                top: 50%;
                                left: 50%;
                                transform: translate(-50%, -50%);
                                font-size: 16px;
                                font-weight: bold;
                                color: #fffceb;
                                line-height: 24px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 3;
                                height: auto;
                                white-space: wrap;
                            }
                        }

                        .img {
                            width: 100%;
                            height: 136px;
                            overflow: hidden;
                        }

                        .title {
                            position: absolute;
                            left: 0;
                            bottom: 0;
                            width: 100%;
                            height: 38px;
                            line-height: 38px;
                            background: rgba(0, 0, 0, 0.6);
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            padding: 0 13px;
                            font-size: 14px;
                            font-weight: bold;
                            color: #ffffff;
                        }
                    }

                    .flex-hide {
                        visibility: hidden;
                        flex: 0 0 240px;
                        display: inline-block;
                    }
                }
            }
        }

        .appraise-cont {
            background: #f9fafb;
            padding: 28px 0 40px;

            .details-appraise {
                width: 1200px;
                margin: 0 auto;
                display: flex;
                padding-left: 217px;
                position: relative;
                z-index: 100;

                .appraise-content {
                    flex: 1;

                    .content-box {
                        width: 100%;
                        padding: 42px 0 0;

                        .appraise-item {
                            display: flex;
                            margin-bottom: 20px;
                            padding-bottom: 30px;
                            border-bottom: 1px solid #eaeaea;

                            .avatar {
                                width: 46px;
                                height: 46px;
                                margin-right: 20px;
                                flex-shrink: 0;
                                border-radius: 50%;
                                background: url('../../../assets/user.png')
                                    no-repeat center/cover;
                            }

                            .appraise-info {
                                flex: 1;

                                .basic-info {
                                    display: flex;
                                    justify-content: space-between;
                                    align-items: center;
                                    padding-bottom: 12px;

                                    .user-info {
                                        display: flex;
                                        align-items: center;

                                        .user-name {
                                            font-size: 14px;
                                            color: #333333;
                                            margin-right: 12px;
                                            flex-shrink: 0;
                                        }

                                        .star-content {
                                            display: flex;
                                            align-items: center;

                                            .star-item {
                                                width: 18px;
                                                height: 18px;
                                                background: url('../../../assets/hzvtc/detail/score-active.png')
                                                    no-repeat center/cover;

                                                &.empty {
                                                    background: url('../../../assets/hzvtc/detail/score-normal.png')
                                                        no-repeat center/cover;
                                                }
                                            }
                                        }
                                    }

                                    .publish-time {
                                        font-size: 12px;
                                        color: #9d9d9d;
                                    }
                                }

                                .appraise-text {
                                    font-size: 14px;
                                    color: #666666;
                                    line-height: 24px;
                                    word-break: break-all;
                                }
                            }
                        }
                    }
                }
            }

            .appraise-container {
                width: 1200px;
                margin: 0 auto;
                height: 227px;
                display: flex;
                flex-direction: column;
                padding-left: 217px;
                position: relative;
                z-index: 100;

                .appraise-header {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 0 15px 0 25px;
                    width: 100%;
                    height: 58px;
                    background: #fff3da;

                    .appraise-star {
                        display: flex;
                        align-items: center;

                        .header-text {
                            margin-right: 20px;
                            font-size: 17px;
                            font-weight: bold;
                            color: #333333;
                            -webkit-text-stroke: 0.3px #ffffff;
                        }

                        .header-score {
                            display: flex;
                            align-items: center;

                            .score-item {
                                width: 26px;
                                height: 26px;
                                background: url('../../../assets/hzvtc/detail/score-active.png')
                                    no-repeat center/cover;
                                cursor: pointer;
                                transition: all 0.3s;

                                &.unActive {
                                    background: url('../../../assets/hzvtc/detail/score-normal.png')
                                        no-repeat center/cover;
                                }
                            }
                        }
                    }

                    .appraise-submit {
                        cursor: pointer;
                        width: 71px;
                        height: 33px;
                        background: #b61e2a;
                        border: 1px solid #f6e9c7;
                        border-radius: 1px 4px 1px 1px;
                        text-align: center;
                        line-height: 32px;
                        font-size: 16px;
                        font-weight: bold;
                        color: #ffffff;
                    }
                }

                .appraise-area {
                    flex: 1;
                    border: 1px solid #fff3da;

                    textarea {
                        width: 100%;
                        height: 100%;
                        border: none;
                        padding: 15px 25px;
                        resize: none;
                        font-size: 16px;
                        color: #666666;

                        &::placeholder {
                            font-size: 16px;
                            color: #b7b6b6;
                        }
                    }
                }
            }
        }
    }
}

::v-deep .footer-container {
    margin: -30px 0 0;
}

.empty-content {
    .empty-text {
        color: #666;
        text-align: center;
        padding: 25px 0;
    }
}

#content,
#appraise {
    position: relative;
    top: -50px;
}

#main {
    position: relative;

    .fixed-nav {
        width: 156px;
        height: 296px;
        background: url('../../../assets/custom/party/detail/menu.png')
            no-repeat center/cover;
        padding: 29px 0 0;
        position: absolute;
        left: calc((100vw - 1200px) / 2);
        top: 530px;
        z-index: 101;

        &.fixed {
            position: fixed;
            left: calc((100vw - 1200px) / 2);
            top: 110px;
        }

        .fixed-nav-item {
            width: 136px;
            height: 44px;
            background: #fff9eb;
            font-size: 16px;
            color: #b1000e;
            line-height: 44px;
            text-align: center;
            margin: 0 auto;
            display: block;
            cursor: pointer;

            &:not(:last-child) {
                margin-bottom: 15px;
            }

            &.active {
                background: #b1000e;
                color: #fff;
                position: relative;

                &::before {
                    content: '';
                    display: inline-block;
                    width: 0;
                    height: 0;
                    border-top: 6px solid transparent;
                    border-right: 6px solid transparent;
                    border-left: 8px solid #fff9eb;
                    border-bottom: 6px solid transparent;
                    position: absolute;
                    right: 7px;
                    top: 50%;
                    transform: translateY(-50%);
                }
            }
        }
    }
}

.empty-box {
    color: #666;
    text-align: center;
    padding: 30px 0;
}

// ant-page 红色
::v-deep .ant-pagination-item-active {
    border-color: transparent;
    background: #b61e2a;
}

::v-deep .ant-pagination-item:hover {
    border-color: #b61e2a;
}

::v-deep .ant-pagination-item:hover a,
::v-deep .ant-pagination-item a {
    color: #666666;
}

::v-deep .ant-pagination-item-active a,
::v-deep .ant-pagination-item-active:hover a {
    color: #ffffff;
}

::v-deep .ant-pagination-prev:focus .ant-pagination-item-link,
::v-deep .ant-pagination-next:focus .ant-pagination-item-link,
::v-deep .ant-pagination-prev:hover .ant-pagination-item-link,
::v-deep .ant-pagination-next:hover .ant-pagination-item-link {
    border-color: #b61e2a;
}

::v-deep .ant-pagination-prev:focus .ant-pagination-item-link .anticon {
    color: #b61e2a;
}

::v-deep .ant-pagination-next:focus .ant-pagination-item-link .anticon {
    color: #b61e2a;
}

::v-deep .ant-pagination-prev:hover .ant-pagination-item-link .anticon {
    color: #b61e2a;
}

::v-deep .ant-pagination-next:hover .ant-pagination-item-link .anticon {
    color: #b61e2a;
}

::v-deep .ant-pagination {
    text-align: center;
    margin-top: 8px;
}

::v-deep .ant-pagination-item,
::v-deep .ant-pagination-prev .ant-pagination-item-link,
::v-deep .ant-pagination-next .ant-pagination-item-link {
    border-radius: 0;
}

.construct-content {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    min-height: calc(100vh - 439px);
    padding: 100px 0;

    img {
        width: 433px;
    }

    p {
        line-height: 1;
        padding-top: 23px;
        font-size: 20px;
        color: #9c9c9c;
    }
}

.party-header {
    position: relative;
    z-index: 200;
}
</style>